import {findChildByName, findChildrenByName} from "../../utils/threeUtils";
import {buildingGroup} from "../../main";
import {
    controlObjectName,
    cutOutsGroupName,
    floorGroupName,
    pillarMeshName,
    roofGroupName,
    supportBeamMeshName,
    wallGroupName,
    wallMeshName
} from "../../constants/nameConstants";
import {Box3, Vector3} from "three";
import {toFixedFloat} from "../../utils/utils";

let wallVolumeUnCutElements = 0;
let wallVolumeCutElements = 0;
let volumes = {
    "roof": {
        "cutVolume": 0,
        "unCutVolume": 0
    },
    "wallElements": {
        "cutVolume": 0,
        "unCutVolume": 0
    },
    "floor": {
        "cutVolume": 0,
        "unCutVolume": 0
    },
    "total": {
        "cutVolume": 0,
        "unCutVolume": 0
    }
};
export let positions = {
    roof: 0,
    walls: 0,
    floor: 0
};

export function calculateVolumes() {
    volumes = {
        "roof": {
            "cutVolume": 0,
            "unCutVolume": 0
        },
        "wallElements": {
            "cutVolume": 0,
            "unCutVolume": 0
        },
        "floor": {
            "cutVolume": 0,
            "unCutVolume": 0
        },
        "total": {
            "cutVolume": 0,
            "unCutVolume": 0
        }
    };

    //Walls
    wallVolumeUnCutElements = 0;
    wallVolumeCutElements = 0;
    let wallGroups = findChildrenByName(buildingGroup, wallGroupName);
    if (wallGroups.length > 0) {
        for (let i = 0; i < wallGroups.length; i++) {
            addVolumesFromWallGroup(wallGroups[i]);
        }
    }

    let pillars = findChildrenByName(buildingGroup, pillarMeshName);
    if (pillars.length > 0) {
        for (let i = 0; i < pillars.length; i++) {
            addVolumesFromPillar(pillars[i]);
        }
    }

    let supportBeams = findChildrenByName(buildingGroup, supportBeamMeshName);
    if (supportBeams.length > 0) {
        for (let i = 0; i < supportBeams.length; i++) {
            addVolumesFromSupportBeam(supportBeams[i]);
        }
    }

    positions.walls = wallGroups.length + pillars.length + supportBeams.length;


    volumes.wallElements.cutVolume = wallVolumeCutElements;
    volumes.wallElements.unCutVolume = wallVolumeUnCutElements;

    //Roof
    wallVolumeUnCutElements = 0;
    wallVolumeCutElements = 0;

    let roofGroup = findChildByName(buildingGroup, roofGroupName);
    let roofpositon = 0;
    if (roofGroup != null) {
        addVolumesFromWallGroup(roofGroup);
        positions.roof = 1;
    }

    volumes.roof.cutVolume = wallVolumeCutElements;
    volumes.roof.unCutVolume = wallVolumeUnCutElements;

    //Floor
    wallVolumeUnCutElements = 0;
    wallVolumeCutElements = 0;

    let floorGroup = findChildByName(buildingGroup, floorGroupName);
    if (floorGroup != null) {
        addVolumesFromWallGroup(floorGroup);
        positions.floor = 1;
    }

    volumes.floor.cutVolume = wallVolumeCutElements;
    volumes.floor.unCutVolume = wallVolumeUnCutElements;

    volumes.total.cutVolume = volumes.wallElements.cutVolume + volumes.roof.cutVolume + volumes.floor.cutVolume;
    volumes.total.unCutVolume = volumes.wallElements.unCutVolume + volumes.roof.unCutVolume + volumes.floor.unCutVolume;

    return volumes;
}

function addVolumesFromWallGroup(wallGroup) {
    /*
    * Die Volumen und daraus resultierend Kostenberechnung wird immer auf Basis der originalVolume ausgeführt.
    * Diese entspricht dem Volumen nach Längenzuschnitt.
    * Wenn anschließend weitere Zuschnitte nötig sind, wird von der Ursprungsgröße mit erhöhtem Preis gerechnet (Verschnitt)
    * Bei nur auf Länge geschnittenen Elementen (OriginalVolume = Aktuelle/Sized Volume wird mit dem regulären Preis später gerechnet)
    */
    let cutOutGroup = findChildByName(wallGroup, cutOutsGroupName);

    for (let i = 0; i < wallGroup.children.length; i++) {
        let element = wallGroup.children[i];
        if (element.type === "Mesh") {
            if (element.userData.removedFromCutOut) {
                continue;
            }

            if (element.name.includes(wallMeshName)) {
                if (element.userData.originalVolume !== undefined && element.userData.sizedVolume !== undefined && element.userData.originalVolume !== null) {
                    if (toFixedFloat(element.userData.originalVolume, 5) === toFixedFloat(element.userData.sizedVolume, 5)) {
                        wallVolumeUnCutElements += element.userData.originalVolume;
                    } else {
                        wallVolumeCutElements += element.userData.originalVolume;
                    }
                } else {
                    console.warn("Ein oder mehrere Meshes haben kein definiertes Volumen");
                }
            } else {
                if (element.userData.originalVolume !== undefined) {
                    wallVolumeCutElements += element.userData.originalVolume;
                } else {
                    console.warn("Ein oder mehrere Meshes haben kein definiertes Volumen");
                }
            }
        }
    }

    //Berechnung zusätzlicher Volumen für Einsätze in Ausschnitte
    if (cutOutGroup !== null) {
        for (let j = 0; j < cutOutGroup.children.length; j++) {
            let cutOut = cutOutGroup.children[j];
            let controlObject = findChildByName(cutOut, controlObjectName);

            //Addition eines möglichen Sturzriegels für Innentüren
            if (controlObject.userData.type === "interiorDoor") {
                let sturzRiegel = findChildByName(cutOut, "sturzRiegel");
                if (sturzRiegel !== null) {
                    let bounds = new Box3().setFromObject(sturzRiegel);
                    let size = bounds.getSize(new Vector3());
                    let volume = size.x * size.y * size.z;
                    wallVolumeCutElements += volume;
                }
            } else if (controlObject.userData.type === "window") {
                let bruestungsRiegel = findChildByName(cutOut, "querbalkenMesh");
                if (bruestungsRiegel !== null) {
                    let bounds = new Box3().setFromObject(bruestungsRiegel);
                    let size = bounds.getSize(new Vector3());
                    let volume = size.x * size.y * size.z;
                    wallVolumeCutElements += volume;
                }
            }
        }
    }
}

function addVolumesFromPillar(pillar) {
    let size = new Box3().setFromObject(pillar).getSize(new Vector3());
    let volume = size.x * size.y * size.z;
    wallVolumeCutElements += volume;
}

function addVolumesFromSupportBeam(supportBeam) {
    let size = new Box3().setFromObject(supportBeam).getSize(new Vector3());
    let volume = size.x * size.y * size.z;
    wallVolumeCutElements += volume;
}
